import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { createElement } from 'react';
import { getStyle, unitParse } from './utils.es.js';
import { DividerTypeEnum } from '@teko-builder/types/shared';
import './InputNumber-7d93e963.js';
import './components/shared/Link.es.js';
import 'rc-select';
import * as DSIcons from '@teko-builder/icons';
import './FormItem-098fa619.js';
import './DateTimePickerMobile-749dc497.js';
import './RadioGroup-4b4abf08.js';
import './Col-475038db.js';
import './Slider-93041044.js';
import './Container-ca9f82d8.js';
import { D as Divider } from './Divider-600cb92e.js';
import './Ripple-abf0f8a0.js';
import './Image-efa43cf5.js';
import './ModalHeader-a3d30e4f.js';
import './Spin-a6892495.js';
import { e as getSizeWithUnit, d as getPropsIcon } from './common-dbaafe9f.js';
import '@teko-builder/types/pb';
import styled from '@emotion/styled';

const PbDivider = (_a) => {
    var { commonStyle, gap, weight, style, align, type, textConfig, iconConfig } = _a, rest = __rest(_a, ["commonStyle", "gap", "weight", "style", "align", "type", "textConfig", "iconConfig"]);
    const _b = commonStyle || {}, { width, color } = _b, restCommonStyle = __rest(_b, ["width", "color"]);
    const renderDivider = () => {
        var _a, _b, _c;
        if (!type)
            return (jsx(Divider, { width: unitParse(width), height: getSizeWithUnit(weight), color: color, dividerStyle: style, align: align, gap: getSizeWithUnit(gap) }));
        const DsIcon = DSIcons[(_a = iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.icon) === null || _a === void 0 ? void 0 : _a.name];
        const IconComponent = !!DsIcon
            ? createElement(DsIcon, getPropsIcon({
                color: (_b = iconConfig.icon) === null || _b === void 0 ? void 0 : _b.color,
                size: (_c = iconConfig.icon) === null || _c === void 0 ? void 0 : _c.size,
            }))
            : null;
        return (jsx(Divider, Object.assign({}, rest, { width: unitParse(width), height: getSizeWithUnit(weight), color: color, dividerStyle: style, align: align, gap: getSizeWithUnit(gap), alignContent: type === DividerTypeEnum.text ? textConfig === null || textConfig === void 0 ? void 0 : textConfig.align : iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.align, spacingContent: type === DividerTypeEnum.text
                ? getSizeWithUnit(textConfig === null || textConfig === void 0 ? void 0 : textConfig.spacing)
                : getSizeWithUnit(iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.spacing) }, { children: type === DividerTypeEnum.text ? (jsx("span", { dangerouslySetInnerHTML: { __html: textConfig === null || textConfig === void 0 ? void 0 : textConfig.text } })) : (IconComponent) })));
    };
    return (jsx(StyledDivider, Object.assign({}, rest, { commonStyle: restCommonStyle }, { children: renderDivider() })));
};
const StyledDivider = styled.div(({ commonStyle }) => `
  ${getStyle(commonStyle)}
`);
PbDivider.displayName = Divider.displayName;

export { PbDivider as P };
